import LeavePageBoundary from './LeavePageBoundary';

export default LeavePageBoundary;
